import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import {
    backgroundGradientOptions,
    buttonVariantOptions,
    textColorOptionsWithWhite,
} from '../utils/builderColorOptions';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';
import S18VideoBackground from '../components/interactive-sections/S18Video/S18VideoBackground';

Builder.registerComponent(S18VideoBackground, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S18Video,
    friendlyName: 'S18 Video',
    inputs: [
        {
            name: 'desktopVideo',
            type: 'file',
            required: true,
            defaultValue:
                'https://customer-b4lv92xmqdr867rr.cloudflarestream.com/0b221cb870c739c08dc49e7adb7f5e73/manifest/video.m3u8',
            allowedFileTypes: ['mp4', 'webm', 'ogg'],
            friendlyName: 'Desktop Video',
            helperText:
                'Upload a video file for desktop display (required), supported formats: mp4, webm, ogg, Please ensure the video is optimized for web use and is under 5MB for best performance.',
        },
        {
            name: 'graphicsHeadlineText',
            type: 'string',
            defaultValue: 'Shave never, Smooth forever',
            friendlyName: 'Graphics Headline Text',
            helperText: 'Main headline text for the graphics overlay',
        },
        {
            name: 'graphicsHeadlineUnderlinedText',
            type: 'string',
            defaultValue: 'Smooth',
            friendlyName: 'Graphics Headline Underlined Text',
            helperText:
                'Specify which word/phrase to underline with turquoise accent. Must match text from headline above (case-insensitive). Only one phrase supported.',
        },
        {
            name: 'graphicsHeadlineColor',
            type: 'string',
            defaultValue: 'White',
            enum: textColorOptionsWithWhite,
            friendlyName: 'Graphics Headline Color',
            helperText: 'Color for the graphics headline text',
        },
        {
            name: 'imageSrcBadge',
            type: 'file',
            defaultValue:
                'https://cdn.builder.io/api/v1/file/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F3bd386d730254ea990ede4bd188d408d',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
            friendlyName: 'Badge Image',
            helperText: 'Upload a badge image or provide an image URL (optional)',
        },
        {
            name: 'imageAltBadge',
            type: 'string',
            defaultValue: 'Badge Alt Text',
            friendlyName: 'Badge Image Alt Text',
            helperText: 'Alt text for the badge image',
        },

        {
            name: 'text',
            type: 'longText',
            defaultValue: "Milan Laser is the nation's #1 provider with {{clinicCount}} locations.",
            friendlyName: 'Text Content',
            helperText:
                'Main text content for the section. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
        },
        {
            name: 'textColor',
            type: 'string',
            defaultValue: 'White',
            enum: textColorOptionsWithWhite,
            friendlyName: 'Text Color',
            helperText: 'Color for the text content',
        },
        {
            name: 'children',
            type: 'string',
            defaultValue: 'Learn More',
            friendlyName: 'Button Text',
            helperText: 'Text to be displayed on the button (this will be passed as button.children)',
        },
        {
            name: 'variant',
            type: 'string',
            required: true,
            friendlyName: 'Button Variant',
            enum: buttonVariantOptions,
            defaultValue: 'overlay',
            helperText:
                'The style of the button: primary (blue), secondary (navy blue - darker than primary), cta (special emphasis)',
        },
        {
            name: 'buttonUrl',
            type: 'string',
            defaultValue: '/process',
            friendlyName: 'Button URL',
            helperText: 'The destination page when the button is clicked (e.g., /services, /contact, /special-offer)',
        },
        {
            name: 'name',
            type: 'string',
            defaultValue: 'Find a Location',
            friendlyName: 'Link Name',
            helperText: 'Name/title for the link (this will be passed as link.name)',
        },
        {
            name: 'href',
            type: 'string',
            defaultValue: '/locations',
            friendlyName: 'Link URL',
            helperText: 'The destination URL for the link (this will be passed as link.href)',
        },
        {
            name: 'linkColor',
            type: 'string',
            defaultValue: 'White',
            enum: textColorOptionsWithWhite,
            friendlyName: 'Link Color',
            helperText: 'Color for the link text',
        },
        ...getBackgroundColorInput({}),
        ...getBackgroundGradientInput({
            backgroundGradientName: 'backgroundGradient',
            backgroundGradientList: backgroundGradientOptions,
            defaultValue: 'BlueTop',
        }),
        ...getPaddingInputs({
            desktopTop: 'small',
            desktopBottom: 'large',
            mobileTop: 'none', //looks better and matches what we have today on our home page
            mobileBottom: 'small',
        }),
    ],
});
